import type { ButtonHTMLAttributes } from "react";

import { Button } from "@/components/ui/Button";
import { cn } from "@/lib/utils";

export interface FilterChipProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "type"> {
  pressed: boolean;
}

/** Multi-select list filter. Selected and unselected share one border box so a wrapping row does not jump. */
export function FilterChip({ pressed, className, children, ...rest }: FilterChipProps): JSX.Element {
  return (
    <Button
      type="button"
      size="sm"
      variant={pressed ? "primary" : "secondary"}
      aria-pressed={pressed}
      className={cn("shrink-0", className)}
      {...rest}
    >
      {children}
    </Button>
  );
}
